<template>
  <div class="tenantMainPage">
    <WelcomeTop/>
    <UnitInfo v-if="!shouldHideSystemIdentities" class="mb-2"/>
    <div v-if="!shouldHideSystemIdentities && this.$store.getters.getUnitSupportsGuests">
      <GuestInfo class="mb-2"/>
    </div>
    <IdentityInfo v-if="this.$store.getters.isLinkedIdentityAllowed"/>
  </div>

</template>

<script>
import WelcomeTop from '@/components/WelcomeTop'
import UnitInfo from "@/components/UnitInfo";
import GuestInfo from "@/components/GuestInfo"
import IdentityInfo from '@/components/IdentityInfo.vue';

export default {
  name: 'PortalHomePage',
  data: () => ({
    showDeviceType: "UNIT",
    buttonTenantDeviceText: "Show Guest Details",
  }),
  components:{
    WelcomeTop,
    UnitInfo,
    GuestInfo,
    IdentityInfo
  },
  computed: {
    shouldHideSystemIdentities() {
      const propertyInfo = this.$store.getters.getPropertyInfo;
      
      // First check if the feature flag is enabled
      const isFeatureEnabled = Object.hasOwn(propertyInfo, 'hideSystemIdentitiesFeature') && 
                               propertyInfo.hideSystemIdentitiesFeature === true;
      
      // Only check unit flag if feature is enabled, otherwise return false
      if (!isFeatureEnabled) {
        return false;
      }
      
      const unit = this.$store.getters.getUnit;
      return unit?.hideSystemIdentities === true;
    }
  },
  methods:{
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin: 40px 0 0;
}
</style>
